import React from 'react'
import classes from './Footer.css'
const Footer = (props) => {
    return (
        <div className={classes.Footer}></div>
    )
}
export default Footer


// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js